import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: "24px",
    paddingBottom: "18px",
    borderRadius: "4px",
    backgroundColor: "white",
  },
  noData: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  expire: {
    color: theme.palette.error.main,
  },
  paid: {
    color: theme.palette.success.main,
  },
  amount: {
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 600,
  },
  selectable: {
    cursor: "pointer",
  },
  negativeValue: {
    color: theme.palette.error.main,
  },
}));
